// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.marginLeft[data-v-2f3b6766] {\r\n  margin-left: 8px;\n}\r\n", ""]);
// Exports
module.exports = exports;
